import { makeEntityScaffold } from '@classpass/saga-tools';
import urls from 'constants/urls';
import { transformKeysToCamelCase } from 'helpers/core';

const handler = ({ httpClient }, payoutId, venueId) => {
  const endpoint = urls.reports.invoiceStatus({ payoutId, venueId });
  return httpClient.get(endpoint).then(({ data }) => transformKeysToCamelCase(data));
};

export default makeEntityScaffold('SAGA.API.PAYOUT_INVOICE_STATUS', handler);
